/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ExportJobStatusSchemaStatus = typeof ExportJobStatusSchemaStatus[keyof typeof ExportJobStatusSchemaStatus];


export const ExportJobStatusSchemaStatus = {
  pending: 'pending',
  processing: 'processing',
  ready: 'ready',
  failed: 'failed',
} as const;
